import React from 'react';
import {
  SimpleGrid,
  Card,
  CardBody,
  Text,
  Stat,
  StatLabel,
  StatNumber,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import { ILivrosResumoConsolidado } from '../../../../../../types/icms';
import { formatCurrency, toNumber } from '../../../../../../utils/FormatFunctions';

interface LivrosResumoCardsProps {
  data?: ILivrosResumoConsolidado;
  isLoading?: boolean;
}

export function LivrosResumoCards({ data, isLoading }: LivrosResumoCardsProps) {
  if (isLoading && !data) {
    return (
      <Flex justify="center" py={6}>
        <Spinner color="primary" />
      </Flex>
    );
  }

  if (!data) return null;

  const cards = [
    {
      label: 'Entradas',
      qtd: data.entradas?.qtd_notas ?? 0,
      total: toNumber(data.entradas?.total_vcontabil),
      icms: toNumber(data.entradas?.total_icms),
      color: '#1976D2',
      bg: '#E3F2FD',
    },
    {
      label: 'Saídas',
      qtd: data.saidas?.qtd_notas ?? 0,
      total: toNumber(data.saidas?.total_vcontabil),
      icms: toNumber(data.saidas?.total_icms),
      color: '#F57C00',
      bg: '#FFF3E0',
    },
    {
      label: 'Serviços',
      qtd: data.servicos?.qtd_notas ?? 0,
      total: toNumber(data.servicos?.total_vcontabil),
      icms: toNumber(data.servicos?.total_icms),
      color: '#9C27B0',
      bg: '#F3E5F5',
    },
  ];

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: data.apuracao_icms ? 4 : 3 }} spacing={3} mb={4}>
      {cards.map(c => (
        <Card key={c.label} borderLeft="4px solid" borderLeftColor={c.color} bg={c.bg}>
          <CardBody p={4}>
            <Stat>
              <StatLabel
                fontSize="11px"
                color="gray.600"
                textTransform="uppercase"
                fontWeight="bold"
              >
                {c.label}
              </StatLabel>
              <StatNumber fontSize="20px" color={c.color}>
                {c.qtd}
              </StatNumber>
              <Text fontSize="11px" color="gray.600" mt={1}>
                Valor contábil: <strong>{formatCurrency(c.total)}</strong>
              </Text>
              <Text fontSize="11px" color="gray.600">
                ICMS: <strong>{formatCurrency(c.icms)}</strong>
              </Text>
            </Stat>
          </CardBody>
        </Card>
      ))}
      {data.apuracao_icms && (
        <Card borderLeft="4px solid" borderLeftColor="#10b981" bg="#E8F5E9">
          <CardBody p={4}>
            <Stat>
              <StatLabel
                fontSize="11px"
                color="gray.600"
                textTransform="uppercase"
                fontWeight="bold"
              >
                Apuração ICMS
              </StatLabel>
              <StatNumber fontSize="20px" color="#10b981">
                {formatCurrency(toNumber(data.apuracao_icms.saldo))}
              </StatNumber>
              <Text fontSize="11px" color="gray.600" mt={1}>
                Débito: <strong>{formatCurrency(toNumber(data.apuracao_icms.debito))}</strong>
              </Text>
              <Text fontSize="11px" color="gray.600">
                Crédito: <strong>{formatCurrency(toNumber(data.apuracao_icms.credito))}</strong>
              </Text>
            </Stat>
          </CardBody>
        </Card>
      )}
    </SimpleGrid>
  );
}
